<template>
  <v-container v-if="person && Object.keys(person).length > 0">
    <GoBackAtTop
      v-if="isCompanyOrder"
      :to="{
        name: 'CardCompanyTypes',
        params: {companyId: this.companyId, personId: this.personId, apprenticenshipId: this.apprenticenshipId, type: $route.params.type}
      }"
      :label="$route.params.type === 'tradecertificate-card' ? $t('order-card.order.title2') : $t('order-card.order.title')"
    />
    <GoBackAtTop
      v-else
      :to="{name: 'CardTypes', params: {type: $route.params.type, personId: this.personId}}"
      :label="$route.params.type === 'tradecertificate-card' ? $t('order-card.order.title2') : $t('order-card.order.title')"
    />

    <template v-if="$route.params.type === 'tradecertificate-card'">
      <h1>{{ $t('order-card.order.title2') }}</h1>
      <MessageBox class="mt-3" type="warning" v-if="isCardInProcess">
        <h6 class="pb-4 title text-uppercase">{{ $t('order-card.message-title') }}</h6>
        <p>{{ $t('order-card.message') }}</p>
      </MessageBox>
        <template v-else>
          <p class="mt-4">{{ $t('order-card.order.tc-p1') }}</p>
          <p class="mt-n1">{{ $t('order-card.order.tc-p2') }}</p>

          <h4 class="mt-6">{{ $t('settings.certificates-title') }}</h4>

          <p class="mb-10">{{ $t('order-card.c-order.tc-ul') }}</p>
          <ul v-for="(t, index) in currentUser.tradeCertificates" :key="index">
            <li class="mt-n7">
              <p>
                {{ getProfessionNameById(t.professionId) }}
                <template v-if="getMachineOrientations(t).length">
                  ({{getMachineOrientations(t).map(it => it.machine.name).join('/')}})
                </template>
              </p>
            </li>
          </ul>

          <p class="mb-6">
            {{ $t('order-card.c-order.tc-p') }}
            <a :href="links.main.bynContact" target="_blank">{{ $t('order-card.order.call-byn') }}</a
            >.
          </p>
        </template>
      </template>

      <template v-else-if="$route.params.type !== 'machine-card'">
        <h1>{{ $t('order-card.order.title') }}</h1>
        <MessageBox class="mt-3" type="warning" v-if="isCardInProcess">
          <h6 class="pb-4 title text-uppercase">{{ $t('order-card.message-title') }}</h6>
          <p>{{ $t('order-card.message') }}</p>
        </MessageBox>
        <template v-else>
          <p class="mt-4">{{ $t('order-card.order.p1') }}</p>
          <p class="mt-n1">{{ $t('order-card.order.p2') }}</p>

          <h4 class="mt-6">{{ $t('order-card.c-order.machines') }}</h4>
          <p class="mb-10">{{ $t('order-card.c-order.machines-ul') }}</p>
          <ul v-for="(o, index) in orientations" :key="index">
            <li class="mt-n7">
              <p>{{ get(o, 'professionMachineOrientation.machine.name', '') }}</p>
            </li>
          </ul>

          <p>
            {{ $t('order-card.c-order.machines-p') }}
            <a :href="links.main.bynContact" target="_blank">{{ $t('order-card.order.call-byn') }}</a
            >.
          </p>
        </template>
      </template>

      <template v-else>
        <h1 class="mt-3">{{ $t('order-card.order.title')}}</h1>

        <!-- Info -->
        <MessageBox class="mt-3" type="warning" v-if="isCardInProcess">
          <h6 class="pb-4 title text-uppercase">{{ $t('order-card.message-title') }}</h6>
          <p>{{ $t('order-card.message') }}</p>
        </MessageBox>

        <template v-else>
          <!-- <p class="mt-4">123{{ $t('order-card.order.p1') }}</p>
          <p class="mt-n1">456{{ $t('order-card.order.p2') }}</p> -->
          <div v-if="isCompanyOrder">
            <h4 class="mt-6">{{ $t('order-card.c-order.owner') }}</h4>
            <p class="mt-n4">{{ person | fullName }}</p>
            <p class="mt-n4">{{ person.personalNumber | formatPnr }}</p>
          </div>

          <h4 class="mt-6">{{ $t('order-card.c-order.machines') }}</h4>
          <p class="mb-10">{{ $t('order-card.c-order.machines-ul') }}</p>
          <ul v-for="(o, index) in orientations" :key="index">
            <li class="mt-n7">
              <p>{{ get(o, 'professionMachineOrientation.machine.name', '') }}</p>
            </li>
          </ul>

          <p>
            {{ $t('order-card.c-order.machines-p') }}
            <a :href="links.main.bynContact" target="_blank">{{ $t('order-card.order.call-byn') }}</a
            >.
          </p>
        </template>
      </template>

      <template v-if="!isCardInProcess">
        <h4>{{ $t('order-card.order.price-title') }}</h4>
        
        <template v-if="$route.params.type && $route.params.type=='tradecertificate-card' && currentUser.tradeCertificates">
          <p>{{ $t('order-card.order.tc-price-title-p') }}</p>
          <p class="semibold">
              <span class="card-price">
                {{ $t('order-card.order.c-price-price', {price: 450}) }}
              </span>
              {{$t('order-card.order.c-price-incl-taxes')}}
          </p>
          <h4 class="mt-4">{{ $t('order-card.order.c-pay-title') }}</h4>
          <p>{{ $t('order-card.order.tc-pay-p') }}</p>
          <v-checkbox class="mt-n1 marked-blue label-top" 
            v-model="useEmail" 
            :label="$t('order-card.order.ship-email', {email: person.email})"
            :disabled="isImitatingUser()"
          ></v-checkbox>
        </template>

        <div class="mt-n3" v-else-if="cardsList && cardsList.length == 0">
          <p v-if="isTradeCertificateOrder">{{ isCompanyOrder ? $t('order-card.order.c-price-title-p') : $t('order-card.order.price-title-p') }}</p>
          <p v-else>
            <span class="card-price">
              {{ $t('order-card.order.c-price-price', {price: 450}) }} 
            </span>
            {{$t('order-card.order.c-price-incl-taxes')}}
          </p>
        </div>

        <div class="mt-n2" v-else>
          <template v-if="isTradeCertificateOrder">
            <!-- if it is the second time ordering  -->
            <p>{{ isCompanyOrder ? $t('order-card.order.c-price-title-p1') : $t('order-card.order.price-title-p1') }}</p>
            <p class="semibold">
              <span class="card-price">
                {{ isCompanyOrder ? $t('order-card.order.c-price-price', {price: 96}) : $t('order-card.order.c-price-price', {price: 120}) }}
              </span>
              {{ isCompanyOrder ? $t('order-card.order.c-price-no-taxes') : '' }}
            </p>
          </template>

          <p class="semibold" v-else>
            <span class="card-price">
              {{ $t('order-card.order.c-price-price', {price: 450}) }} 
            </span>
            {{$t('order-card.order.c-price-incl-taxes')}}
          </p>
        </div>

        <div v-if="isCompanyOrder" class="mt-2">
          <h4>{{ $t('order-card.order.c-pay-title') }}</h4>
          <p>{{ $t('order-card.order.c-pay-p') }}</p>
          <ActionButton
            type="application"
            @click="
              $nextTick(() => {
                $router.push({
                  name: 'CompanyWorkplaces',
                  params: {id: companyId}
                })
              })
            "
            :isDisabled="isImitatingUser()"
            >{{ $t('labels.card-machine-go-to-workplace') }}</ActionButton
          >
          <v-select
            class="mt-6"
            :items="workplaces"
            v-model="workplaceId"
            :rules="[rules.required]"
            item-text="name"
            item-value="id"
            outlined
            :label="$t('labels.c-select-workplace')"
            append-icon="$sl-arrow-down"
            :disabled="isImitatingUser()"
          >
          </v-select>

          <v-select
            class="mt-n2"
            :items="deliveryAddresses"
            v-model="selectedDelivery"
            item-text="text"
            item-value="deliveryAddressId"
            outlined
            label="Kortet skall skickas till"
            append-icon="$sl-arrow-down"
            :disabled="isImitatingUser()"
            return-object
          >
          </v-select>

          <div class="mb-2">
            <h4>{{ $t('labels.add-new-address-title') }}</h4>
            <p v-if="!setNewAddressFieldsVisible">{{ $t('labels.add-new-address-text') }}</p>
          </div>

          <v-form ref="form" v-model="formIsValid" lazy-validation v-if="setNewAddressFieldsVisible">
            <v-text-field
              :label="$t('fields.address-2')"
              outlined
              v-model="newAddress.postalAddress1"
              :rules="[rules.required]"
            />

            <v-text-field
              :label="$t('fields.zip')"
              outlined
              class="mt-n3"
              v-model="newAddress.postalZip"
              :rules="[rules.required, rules.integer, rules.hasLength(5, newAddress.postalZip)]"
            />

            <v-text-field
              :label="$t('fields.city')"
              outlined
              class="mt-n3"
              v-model="newAddress.postalCity"
              :rules="[rules.required]"
            />

            <div class="d-flex mt-n4 mb-10 justify-end">
              <ActionButton
                type="application"
                actionIcon="$sl-cancel"
                :style="{ flex: 'unset !important', minWidth: 'auto !important' }"
                @click="setNewAddressFieldsVisible = false"
                >{{ $t('labels.cancel') }}</ActionButton
              >

              <ActionButton
                actionIcon="$sl-add"
                class="ml-4"
                :style="{ flex: 'unset !important', minWidth: 'auto !important' }"
                @click="addNewAddress()"
                >{{ $t('labels.add') }}</ActionButton
              >
            </div>
          </v-form>
          
          <ActionButton
            type="application"
            :isDisabled="isImitatingUser()"
            class="mb-8"
            v-else
            @click="setNewAddressFieldsVisible = true"
            >{{ $t('labels.click-to-add-new-address') }}</ActionButton
          >
        </div>
        <div v-if="isCompanyOrder">
          <div class="d-flex mt-4" v-if="workplaceHasInvoiceEmail">
            <v-checkbox class="mt-n1 marked-blue" 
              v-model="useEmail" 
              :label="$t('order-card.order.ship-email', {email: workplace.invoiceAddressEmail})"
              :disabled="isImitatingUser()"
            ></v-checkbox>
          </div>
        </div>

        <ActionButton v-if="$route.params.type=='tradecertificate-card'" actionIcon="$sl-invitation" 
          @click="createPrintOrder" 
          :isDisabled="isCardInProcess || isImitatingUser()"
        >
          {{$t('order-card.order.title2')}}
        </ActionButton>

        <ActionButton v-else actionIcon="$sl-equipment-truck" 
          @click="createPrintOrder" 
          :isDisabled="isCardInProcess || isImitatingUser() || setNewAddressFieldsVisible"
        >
          {{$t('labels.card-machine-orders')}}
        </ActionButton>
      </template>
  </v-container>
</template>

<script>
import GoBackAtTop from '@/components/Common/GoBackAtTop'
import CountrySelector from '@/components/Common/CountrySelector'
import API from '@/services/api.js'
import ActionButton from '@/components/Common/ActionButton'
import WorkplacesList from '@/components/Common/Workplace/WorkplacesList'
import MessageBox from '@/components/Common/MessageBox'
import {mapGetters} from 'vuex'
import filter from 'lodash/filter'
import get from 'lodash/get'
import find from 'lodash/find'
import {CompanyRoles} from '@/components/mixins'
import {RulesMixin} from '@/components/mixins'
import { pick, uniqBy } from 'lodash'
export default {
  mixins: [RulesMixin, CompanyRoles],
  components: {
    CountrySelector,
    WorkplacesList,
    MessageBox,
    ActionButton,
    GoBackAtTop
  },
  data() {
    return {
      links: require('../../lib/external-links.json'),
      changeAdress: false,
      useEmail: false,
      reasons: [
        { id: 1, text: 'Tappat, förlorat eller trasigt kort' }
      ],
      person: {},
      workplaceId: null,
      workplaces: [],
      workplace: {},
      educations: [],
      cardsList: [],
      orientations: [],
      createData: {
        deliveryAttention: '',
        deliveryPostalAddress: '',
        deliveryPostalAddress2: '',
        deliveryZipCode: '',
        deliveryCity: '',
        deliveryCountry: ''
      },
      companyId: null,
      apprenticenshipId: null,
      personId: null,
      newAddresses: [],
      newAddress: { postalAddress1: null, postalZip: null, postalCity: null },
      selectedDelivery: null,
      setNewAddressFieldsVisible: false,
      formIsValid: true
    }
  },

  created() {
    this.createData.deliveryCountry = 'SE'
    if(!(this.$route.params && this.$route.params.type && this.$route.params.type!='' || this.$route.params.companyId))
      this.$router.push("/");

    if (this.$route && this.$route.params) {
      this.companyId = this.$route.params.companyId ? this.$route.params.companyId : null
      this.personId = this.$route.params.personId ? this.$route.params.personId : null
      this.apprenticenshipId = this.$route.params.apprenticenshipId ? this.$route.params.apprenticenshipId : null
    }

    if (this.personId) {
      this.init()
    }
  },
  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isDepartmentAdministrator', 'isImitatingUser']),
    ...mapGetters("basic", ["basicProfessions", "hasProfessionOrientations", "getProfessionNameById", "getProfessionById",]),
    isCompanyOrder() {
      return Boolean(this.$route && this.$route.params && this.$route.params.companyId)
    },
    workplaceHasInvoiceEmail() {
      if (!this.workplaceId) return
      this.workplace = find(this.workplaces, ['id', this.workplaceId])
      if (this.workplace && this.workplace.invoiceAddressEmail) {
        return true
      }

      return false
    },
    isCardInProcess() {
      const thisCardConcerns = this.$route.params.companyId ? this.personId : this.currentUser.id
      const allPrintOrders = get(this, 'cardsList', [])

      const hasCardInProgress = allPrintOrders.some((o) => {
        return o.print.personId === thisCardConcerns &&
          ['created', 'approved', 'awaitingPayment'].includes(o.printOrderState.state)
      })
      return hasCardInProgress
    },

    apprenticeData() {
      let person = { ...pick(this.person, ['address1', 'city', 'zip']) }
      if ( !person ) return null

      // Prepend all keys with `postal`
      person = Object.fromEntries(
        Object.entries(person).map(([key, value]) => 
          [`postal${key.charAt(0).toUpperCase() + key.substring(1)}`, value]
        )
      )
      
      // Add additional required properties below
      person = { ...person, name: `${this.person?.firstName} ${this.person?.lastName}` }
      
      // Enable sending invoice to person
      this.workplaces = [ ...this.workplaces, person ]
      
      return person
    },

    deliveryAddresses() {
      const workplaces = [ ...this.workplaces ]

      return uniqBy([ ...workplaces, ...this.newAddresses, this.apprenticeData ].map((address, idx) => ({
          ...address,
          deliveryAddressId: idx + 1,
          text: `${ address.name || 'Ny address' } (${ address.postalAddress1 }, ${ address.postalZip } ${ address.postalCity })`
        }
      )), 'postalAddress1')
    },

    isTradeCertificateOrder() {
      return get(this, '$route.params.type', '') === 'tradecertificate-card'
    }
  },
  methods: {
    get: get,
    init() {
      this.getPrintCardsList()
      this.getUser()
      this.fetchworkplaces()
    },
    getMachineOrientations(tr) {
      const prof = this.getProfessionById(tr.professionId)

      return this.currentUser.machinequalifications.filter((mq) => {
        const profMachineIds = prof.machineOrientations.map(mo => mo.machineId)
        return (profMachineIds.includes(mq.machineId) && mq.approvedById && mq.approvedById > 0)
      })
    },
    getPrintCardsList() {
      API.getPrintOrdersList().then(({data = {}}) => {
        console.log("cardlist::", data)
        this.cardsList = data
      })
      .catch(error => {
        console.log('Error getting person QT:', error)
      })
    },
    /**
     * @vuese
     * Used to go to get person education
     * @arg The argument is an integer representing user id
     */
    async getUser() {
      if (!this.personId) return
      let apprenticeshipOrPersonId = 0
      const getData = this.isCompanyOrder ? 'getApprenticeship' : 'getPerson'
      apprenticeshipOrPersonId = this.isCompanyOrder ? this.apprenticenshipId : this.personId
      API[getData](apprenticeshipOrPersonId)
        .then(async res => {
          if (this.isCompanyOrder) {
            this.person = await res.data.apprentice
            this.educations = filter(this.person.educations, function (o) {
              return o.basicEducationCertificate != null
            })
            this.orientations = get(this.educations[0], 'educationProfessionOrientations', [])
          } else {
            this.person = res.data
            //- For the moment it is supposed to have only one education with K-tid active , but in the future can have more
            this.educations = filter(this.person.educations, function (o) {
              return o.qualificationTime != null
            })

            this.orientations = get(this.educations[0], 'educationProfessionOrientations', [])
          }
        })
        .catch(error => {
          console.log('Store - failed to get user: ' + error)
        })
    },
    /**
     * @vuese
     * Used to fetch workplaces
     * @arg The argument is an integer value representing company id
     */
    fetchworkplaces() {
      if (this.companyId > 0) {
        API.getCompanyWorkspaces(Number(this.companyId))
          .then(res => {
            let depIds = this.getCurrentUserDepartmentsIds(
              this.companyId,
              this.isAdministrator,
              this.isDepartmentAdministrator(this.companyId)
            )
            if (this.hasDepartments(this.companyId) == true) {
              this.workplaces = res.data.filter(r => r.departmentIds.find(d => includes(depIds, d)))
            } else {
              this.workplaces = res.data
            }
            this.workplaces = filter(this.workplaces, ['isInvoiceWorkplace', true])
            if (this.workplaces && this.workplaces.length === 1) {
              this.workplaceId = this.workplaces[0].id
            }
          })
          .catch(err => {
            console.log('errro:', err)
          })
      }
    },
    /**
     * @vuese
     * Used to go to create an person card
     * @arg The argument is an integer representing education id
     */
    createPrintOrder() {
      let d = {}
      this.changeAdress
        ? (d = this.createData)
        : this.isCompanyOrder
        ? (d = {
            /* to replace the object person if in this case data will be different Which probably will be */
            deliveryAttention: this.selectedDelivery ? this.selectedDelivery?.name : this.workplace.deliveryAddressAttention ? `${this.workplace.deliveryAddressAttention}` : null,
            deliveryPostalAddress: this.selectedDelivery ? this.selectedDelivery?.postalAddress1 : this.workplace.postalAddress1 ? this.workplace.postalAddress1 : null,
            deliveryPostalAddress2: this.apprenticeData.name === this.workplaceId ? this.person.address2 : this.workplace.postalAddress2 ? this.workplace.postalAddress2 : null,
            deliveryZipCode: this.selectedDelivery ? this.selectedDelivery?.postalZip : this.workplace.postalZip ? this.workplace.postalZip : null,
            deliveryCity: this.selectedDelivery ? this.selectedDelivery?.postalCity : this.workplace.postalCity ? this.workplace.postalCity : null,
            deliveryCountry: this.apprenticeData.name === this.workplaceId ? this.person.country : this.workplace.postalCountry ? this.workplace.postalCountry : null,
            invoiceAttention: this.apprenticeData.name === this.workplaceId ? this.person.name : this.workplace.deliveryAddressAttention
              ? `${this.workplace.deliveryAddressAttention}`
              : null,
            invoiceCity: this.apprenticeData.name === this.workplaceId ? this.person.city : this.workplace.postalCity ? this.workplace.postalCity : null,
            invoiceCountry: this.apprenticeData.name === this.workplaceId ? this.person.country : this.workplace.postalCountry ? this.workplace.postalCountry : null,
            invoicePostalAddress: this.apprenticeData.name === this.workplaceId ? this.person.address1 : this.workplace.postalAddress1 ? this.workplace.postalAddress1 : null,
            invoicePostalAddress2: this.apprenticeData.name === this.workplaceId ? this.person.address2 : this.workplace.postalAddress2 ? this.workplace.postalAddress2 : null,
            invoiceZipCode: this.apprenticeData.name === this.workplaceId ? this.person.zip : this.workplace.postalZip ? this.workplace.postalZip : null
          })
        : (d = {
            deliveryAttention:
              this.person.firstName && this.person.lastName ? `${this.person.firstName} ${this.person.lastName}` : null,
            deliveryPostalAddress: this.person.address1 ? this.person.address1 : null,
            deliveryPostalAddress2: this.person.address2 ? this.person.address2 : null,
            deliveryZipCode: this.person.zip ? this.person.zip : null,
            deliveryCity: this.person.city ? this.person.city : null,
            deliveryCountry: this.person.country ? this.person.country : 'SE'
          })

      d.deliveryWorkplaceId = this.workplaceId ? this.workplaceId : null
      d.invoiceEmail = this.useEmail
        ? this.workplace.invoiceAddressEmail
          ? this.workplace.invoiceAddressEmail
          : this.person.email
        : ''
      d.price = (this.isTradeCertificateOrder && !get(this, 'cardsList', []).length) ? 0 : 450

      d.reason = this.reasons.find(r => r.id === this.$route.params.reasonId)?.text || 'Beställer ett första kort'

      if(this.$route.params.type === 'tradecertificate-card') {
        this.createTCPrintOrder(d)
      }
      else {
      API.createPrintOrder(this.educations[0].id, {data: d})
        .then(({data = {}}) => {
          this.$nextTick(() => {
            this.$router.push({
              name: 'CardThankYou', params: {type: this.$route.params.type}
            })
          })
        })
        .catch(error => {
          console.log('Store - failed to get user: ' + error)
        })
      }
    },

    createTCPrintOrder(d) {
      let compId = get(this, 'currentUser.employments[0].companyId', null)
      let compName = get(this, 'currentUser.employments[0].company.name', null)
      d.companyId = compId
      d.companyName = compName
      d.price = 450
      API.createTCPrintOrder(this.$route.params.type === 'tradecertificate-card' ? this.personId : this.currentUser.id, {data: d})
        .then(response => {

          this.$nextTick(() => {
            this.$router.push({
              name: 'CardThankYou', params: {type: this.$route.params.type, personId: this.$route.params.type === 'tradecertificate-card' ? this.personId : this.currentUser.id}
            })
        })
      })
      .catch(error => {
        console.log('Store - failed to get user: ' + error)
      })
    },

    addNewAddress() {
      if ( !this.$refs.form.validate() )
        return this.$events.fire('showError', this.$t('errors.form-validation'))

      this.newAddresses = [ ...this.newAddresses, this.newAddress ]
      this.resetNewAddressFields()
      this.$events.fire('showInfo', this.$t('success.saved'))
    },

    resetNewAddressFields() {
      this.newAddress = { name: null, postalAddress1: null, postalZip: null, postalCity: null }
      this.setNewAddressFieldsVisible = false
    }
  }
}
</script>
